import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DefaultComponent } from "./layout/default.component";

import { AuthGuard } from './helpers';

//import { ClientesComponent, ClienteDetailComponent } from "@app/clientes";
//import { FluxosComponent, FluxoDetailComponent } from "@app/fluxos";
//import { ConfigComponent, ConfigDetailComponent } from "@app/config";
//import { ExesComponent } from "@app/exes";


// import {FluxosComponent} from "./fluxos/fluxos.component"

const routes: Routes = [
  // {
  //   path: "",
  //   component: DefaultComponent,
  //   canActivate: [AuthGuard],
  //   children: [
  //     { path: "clientes", component: ClientesComponent, canActivate: [AuthGuard] },
  //     { path: "clienteDetail/:id", component: ClienteDetailComponent, canActivate: [AuthGuard] },
  //     { path: "fluxos", component: FluxosComponent, canActivate: [AuthGuard] },
  //     { path: "fluxos/:id", component: FluxoDetailComponent, canActivate: [AuthGuard] },
  //     { path: "config", component: ConfigComponent, canActivate: [AuthGuard] },
  //     { path: "config/:id", component: ConfigDetailComponent, canActivate: [AuthGuard] },
  //     { path: "exes", component: ExesComponent, canActivate: [AuthGuard] },
  //     //{ path: "config/:id", component: ConfigDetailComponent },
  //   ],
  // },

  {
    path: 'auth',
    loadChildren: () => import('@app/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'utilizadores',
    loadChildren: () => import('@app/utilizadores/utilizadores.module').then(m => m.UtilizadoresModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'horas',
    loadChildren: () => import('@app/horas/horas.module').then(m => m.HorasModule),
    canActivate: [AuthGuard]
  },
{
    path: 'concursos',
    loadChildren: () => import('@app/concursos/concursos.module').then(m => m.ConcursosModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'licenca',
  //   loadChildren: () => import('@app/licenca/licenca.module').then(m => m.LicencaModule),
  //   canActivate: [AuthGuard]
  // },

  // home
  { path: '', component: DefaultComponent, canActivate: [AuthGuard] },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
